module.exports = __webpack_public_path__ + "et.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/et.svg
// module id = 795
// module chunks = 0